import script from "./CommentListCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentListCard.vue?vue&type=script&setup=true&lang=ts"

import "./CommentListCard.vue?vue&type=style&index=0&id=30d3b27a&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30d3b27a"]])

export default __exports__